<div class="modal-header">
  <h4 id="upper">Details Action PDC ({{filteredtems.length}}) </h4>

  <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="container-fluid">


    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">

                    <div class="col-md-12 d-flex justify-content-end">
                        <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                            <label class="d-inline-flex align-items-center">
                                Rechercher:
                                <input type="text" name="searchTerm" [(ngModel)]="searchTerm"(keyup)="filterProjet()" 
                                    class="form-control form-control-sm ms-2" aria-controls="tickets-table">
                            </label>
                        </div>
                    </div>

                    <div class="table-responsive mt-3">
                        <table class="table table-centered datatable dt-responsive nowrap"
                        style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                        <thead class="thead-light rwd-table">
                          <tr>
                            <th>#</th>
                            <th>Code</th>
                            <th>Libellé</th>
                            <th style="white-space: nowrap;">Poids (%)</th>
                            <th style="white-space: nowrap;">Montant Total</th>
                            <th style="white-space: nowrap;">Montant Mairie</th>
                            <th style="white-space: nowrap;">Montant FADeC/FIC</th>
                            <th style="white-space: nowrap;">Montant Non FADeC</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of paginatedProjets; let i = index">
                            <td>{{ i + firstProjets +1 }}</td>
                            <td>{{ item?.action.code }}</td>
                            <td>{{ item?.action.libelle }}</td>
                            <td style="white-space: nowrap;">{{ item?.poids }}</td>
                            <td style="white-space: nowrap;" class="text-end">{{ item?.mt_total | formatMoney:null}}</td>
                            <td style="white-space: nowrap;"class="text-end">{{ item?.mt_commune  | formatMoney:null }}</td>
                            <td style="white-space: nowrap;"class="text-end">{{ item?.mt_fadec  | formatMoney:null }}</td>
                            <td style="white-space: nowrap;" class="text-end">{{ item?.mt_non_fadec  | formatMoney:null }}</td>
                          </tr>
                        </tbody>
                      </table>
                      

                    </div>

                    <div class="d-flex justify-content-center" *ngIf="isLoading === false">
                        <div class="container">
                          <div class="row">
                            <div class="text-center">
                              <h6 id="graycolor">Chargement en cours...</h6>
                              <div class="loader4"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="paginatedProjets.length === 0 && isLoading === true" class="d-flex justify-content-center">
                        <div class="container">
                          <div class="row">
                            <div class="text-center">
                              <h5 id="graycolor">Aucune donnée trouvée</h5>
                            </div>
                          </div>
                        </div>
            
                      </div>



                    <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets"
                        [rows]="rowsProjets" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
                    </p-paginator>
                </div>
            </div>

        </div>

    </div>
</div>

<p-confirmDialog />
<p-toast />
